import { useReducer } from 'react';
import { AuthContext } from './AuthContext';
import { authReducer } from './authReducer';
import {types} from '../types/types'
import { loginAcceso,recuperarAcceso,modificarContrasena} from 'data/Auth';

const init=()=>{

    
    if(localStorage.getItem('user') !== undefined) {
        const user=JSON.parse(localStorage.getItem('user'));
        return {
            logged:!!user,
            user:user
        }
    }
    else{
        return {
            logged:false,
            user:''
        }
    }
    /*
    return {
        logged:!!user,
        user:user
    }*/

}
export const AuthProvider=({children}) =>{
    const [ authState,dispatch]=useReducer(authReducer,{},init)
    const login=async({Usuario,Contrasena}) =>{
        const respuesta=await loginAcceso({Usuario,Contrasena});
        if(respuesta.success){
            const action={type:types.login,payload:respuesta.data}
            localStorage.setItem('user',JSON.stringify(respuesta.data))
            dispatch(action);
        }
        return respuesta;
        
    }
    const logout=async()=>{
        localStorage.removeItem('user');
        const action={type:types.logout}
        dispatch(action)
    }
    const recuperar= async({UsuarioOCorreo})=>{
        const respuesta=await recuperarAcceso({UsuarioOCorreo});
        return respuesta;
    }
    const modificarPass= async({Contrasena,ContrasenaConfirmacion})=>{    
        const user=JSON.parse(localStorage.getItem('user'));
        const respuesta=await modificarContrasena({Contrasena,ContrasenaConfirmacion},user.Token);
        if(respuesta.sessionover==1){
            await logout();
        }
        else if(respuesta.success==1){
            localStorage.removeItem('user');
            const action={type:types.login,payload:respuesta.data}
            localStorage.setItem('user',JSON.stringify(respuesta.data))
            dispatch(action);                        
            /*
            localStorage.removeItem('user');
            localStorage.setItem('user',JSON.stringify(respuesta.data))
            */
        }
        return respuesta;
    }
    return (
        <AuthContext.Provider value={ 
            {
                ...authState,
                login,
                logout,
                recuperar,
                modificarPass
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}